import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Pages } from 'core/pages';

const Dashboard = lazy(() => import('./Dashboard'));
const List = lazy(() => import('./List'));
const Create = lazy(() => import('./Create'));
const ResourcePage = lazy(() => import('./ResourcePage'));
const Versions = lazy(() => import('./Version'));
const Update = lazy(() => import('./Update'));

export function AssetRoutes() {
  return (
    <Routes>
      <Route path={Pages.cms.asset.meta.path}>
        <Route
          index
          element={(<Dashboard />)}
        />
        <Route
          path={Pages.cms.asset.list.meta.path}
          element={(<List />)}
        />
        <Route
          path={Pages.cms.asset.create.meta.path}
          element={(<Create />)}
        />
        <Route
          path={Pages.cms.asset.read.meta.path}
          element={(<ResourcePage />)}
        />
        <Route
          path={Pages.cms.asset.versions.meta.path}
          element={(<Versions />)}
        />
        <Route
          path={Pages.cms.asset.update.meta.path}
          element={(<Update />)}
        />
      </Route>
    </Routes>
  );
}
